// components/CookieConsentBanner.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import './CookieConsentBanner.css';

const CookieConsentBanner = ({ onChooseOption }) => {
  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <h2>Cookie-Einstellungen</h2>
        <p>
          Diese Website verwendet Cookies, um Ihre Benutzererfahrung zu verbessern. 
          Weitere Informationen finden Sie in unserer&nbsp;
          <Link to="/datenschutz">Datenschutzerklärung</Link>.
        </p>
        <div className="cookie-buttons">
          <button className="btn" onClick={() => onChooseOption('essenziell')}>Essenziell</button>
          <button className="btn" onClick={() => onChooseOption('statistik')}>Statistik</button>
          <button className="btn" onClick={() => onChooseOption('marketing')}>Marketing</button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
